/** @jsxImportSource @emotion/react */

import { FC } from "react";
import useDocumentDetails from "../../../../hooks/useDocumentDetails";
import SentQuotationsTable from "../../DocumentDetails/components/SentQuotationsTable";
import { Result } from "../../../../graphql/__GENERATED__/types";
import Row from "../../../../components/Grid/Row";
import Column from "../../../../components/Grid/Column";
import Button from "../../../../components/Button";
import DownloadIcon from "../../../../components/Icons/downloadIcon";
import { ColorNames } from "../../../../theme";
import Typography from "../../../../components/Typography";

const Quotations: FC = () => {
  const {
    handleDownloadComparisonPdf,
    documentData: { selectedSimulationResults },
  } = useDocumentDetails();
  return (
    <Row justify="between" align="center">
      <Column xs={12} lg={9}>
        <Typography
          variant="textLarge"
          component="p"
          margin="lg"
          align="left"
          uppercase
          color={ColorNames.GREEN}
        >
          Estas são as <strong>melhores coberturas</strong> para sua lavoura:
        </Typography>
        <SentQuotationsTable results={selectedSimulationResults as Result[]} />
      </Column>
      <Column xs={12} lg={3}>
        <Button
          text="Baixe a tabela completa"
          icon={<DownloadIcon color={ColorNames.GREEN} />}
          style="outlinePrimary"
          onClick={handleDownloadComparisonPdf}
        />
        <Typography variant="textMedium" component="p" margin="md" align="left">
          Aqui você pode baixar a tabela de cotações, com todos os valores, em
          formato pdf.
        </Typography>
      </Column>
    </Row>
  );
};

export default Quotations;
